let backToTop = {

    /**
     * The scroll offset after which the button appears
     */
    scrollOffset: 200,

    /**
     * Scrolling speed of the back to top button
     */
    scrollSpeed: 1000,

    /**
     * Tracks the previous scroll position
     */
    lastScrollTop: 0,

    /**
     * Selector for the back to top button
     */
    backToTopSelector: null,

    /**
     * Flag for disabling scrolling functionality
     */
    scrollingDisabled: false,

    /**
     * jQuery object for the back to top button
     */
    $backToTopObject: null,

    /**
     * jQuery object for the footer
     */
    $footerObject: null,

    /**
     * Sets the value of selector and the object. It then initializes the main functionalities of the button
     * @param {string}backToTopHtmlId Html ID for the back to top button
     * @returns {void}
     */
    initializeBackToTop: function (backToTopHtmlId) {
        this.backToTopSelector = '#' + backToTopHtmlId;
        this.$backToTopObject = jQuery(this.backToTopSelector);
        this.$footerObject = jQuery('footer');

        if (this.$backToTopObject.length) {
            jQuery(window).scroll(this.backToTopScrollDirection.bind(this));
            this.$backToTopObject.on('click', this.backToTopClickEvent.bind(this));
        }
    },

    /**
     * Tracks the direction of a user's scrolling. Allows customization of the button's behavior based on
     * scroll direction. Also gets the current opacity and position of the button for animation smoothing.
     * @returns {void}
     */
    backToTopScrollDirection: function () {
        this.setOpacity();
        this.setPosition();
        this.footerBehaviour();
        let currentScroll = jQuery(window).scrollTop();
        if (currentScroll > this.lastScrollTop && this.scrollingDisabled === false) {
            // Direction: Down
            this.hideButton();
        } else {
            // Direction: Up
            this.displayButton();
        }
        this.lastScrollTop = currentScroll;
    },

    /**
     * On button click, scroll to the top of the page.
     * Disables the button and its scrolling functionality when clicked
     * @returns {void}
     */
    backToTopClickEvent: function () {
        this.scrollingDisabled = true;
        this.$backToTopObject.prop('disabled', true);
        jQuery('html, body').animate(
            {scrollTop: 0},
            this.scrollSpeed,
            function () {
                this.scrollingDisabled = false;
                this.$backToTopObject.prop('disabled', false);
            }.bind(this)
        );
    },

    /**
     * Sets the opacity of the button
     * Used in fadeIn and fadeOut to smooth the animations by fading from the current opacity
     * Helpful in cases where animations are played rapidly
     * @returns {void}
     */
    setOpacity: function () {
        let currentOpacity = this.$backToTopObject.css('opacity');
        this.$backToTopObject.css("--current-opacity", currentOpacity);
    },

    /**
     * Sets the bottom css property of the button
     * Used to smooth the fadeOut animation by beginning it from the current position
     * Helpful in cases where animations are played rapidly
     * @returns {void}
     */
    setPosition: function () {
        let currentPosition = this.$backToTopObject.css('bottom');
        this.$backToTopObject.css("--current-position", currentPosition);
    },

    /**
     * Displays the button by fading it based on your scroll offset.
     * @returns {void}
     */
    displayButton: function () {
        if (jQuery(window).scrollTop() > this.scrollOffset) {
            this.$backToTopObject.removeClass('fade-out');
            this.$backToTopObject.addClass('fade-in');
        } else {
            this.$backToTopObject.removeClass("fade-in");
            this.$backToTopObject.addClass("fade-out");
        }
    },

    /**
     * Hides the button
     * @returns {void}
     */
    hideButton: function () {
        this.$backToTopObject.removeClass("fade-in");
        this.$backToTopObject.addClass('fade-out');
    },

    /**
     * Controls the button's behaviour in the footer and prevents the button from scrolling past it.
     * @returns {void}
     */
    footerBehaviour: function () {
        if (this.$footerObject.length) {
            let scrollPosition = jQuery(window).scrollTop() + jQuery(window).height();
            let footerBottomOffset = this.$footerObject.offset().top + this.$footerObject.outerHeight();
            if (this.shouldLockIn() && scrollPosition >= footerBottomOffset) {
                let rightOffset = parseInt(this.$backToTopObject.css("right"), 10);
                let offset = scrollPosition - footerBottomOffset + rightOffset + 'px';
                this.$backToTopObject.css("--current-position", offset);
                this.$backToTopObject.addClass("lock-in-footer");
            } else {
                this.$backToTopObject.removeClass("lock-in-footer");
            }

            if (this.isInFooter()) {
                this.$backToTopObject.addClass("in-footer");
            } else {
                this.$backToTopObject.removeClass("in-footer");
            }
        }
    },

    /**
     * Checks if the back to top button should be locked in the footer based on the footer's width.
     * Only does this to avoid overlapping other elements on the bottom of a page.
     * This is mainly used for BCM compatibility reasons since the BCM footer is styled differently.
     * @returns {boolean} Returns true if the button should be locked in the footer, false otherwise.
     */
    shouldLockIn: function () {
        let viewportWidth = jQuery(window).innerWidth();
        let buttonRightOffset = parseInt(this.$backToTopObject.css("right"), 10);
        let footerWidth = this.$footerObject.outerWidth();
        let footerRightOffset = (viewportWidth - footerWidth)/2;
        let buttonWidth = this.$backToTopObject.outerWidth();
        return viewportWidth - (buttonRightOffset + footerRightOffset + buttonWidth) <= footerWidth;
    },

    /**
     * Checks if the back to top button is positioned over the footer.
     * @returns {boolean} Returns true or false depending on whether the button is in the footer.
     */
    isInFooter: function () {
        let buttonOffset = this.$backToTopObject.offset().top;
        let footerOffset = this.$footerObject.offset().top;
        let viewportWidth = jQuery(window).innerWidth();
        let buttonRightOffset = parseInt(this.$backToTopObject.css("right"), 10);
        let footerWidth = this.$footerObject.outerWidth();
        let footerRightOffset = (viewportWidth - footerWidth)/2;
        return (buttonOffset >= footerOffset) && (viewportWidth - (buttonRightOffset + footerRightOffset) <= footerWidth);
    }
};

jQuery(document).ready(function () {
    backToTop.initializeBackToTop('back-to-top');
});
